   function triggerChange(){
   $('#chks1').trigger("change");
   }
   $('#chks1').change(function() {

   if(this.checked) {
data = {
      "id": 48048032940314,
      "quantity": 1
      }
$.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json'
  });
   } else {
data = {
      "id": 48048032940314,
      "quantity": 0
      }
$.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: data,
    dataType: 'json'
  });
    }
    });

document.addEventListener('DOMContentLoaded', function() {
  // Check if product has multiple variants
  if (meta && meta.product && meta.product.variants && meta.product.variants.length > 1) {
    const quantitySwatches = document.querySelector('.quantity-swatches');
    if (quantitySwatches) {
      quantitySwatches.style.display = 'none';
    }
    return;
  }
  
  // Get current variant price and update display
  let off_amount = $('.product-label--sale').text(); 
  let current_price = $('.price__current').text().match(/\d+/); 
  
  document.querySelector('.swatch-price').textContent = off_amount;
  let two_price = ((current_price/100) * 2 - 200);
  document.querySelector('.swatch-price2').textContent = '₹'+ two_price;
  
  // Add click animations for swatches
  const swatches = document.querySelectorAll('.swatch');
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function() {
      swatches.forEach(s => s.classList.remove('selected'));
      this.classList.add('selected');
    });
  });

  // Listen for cart drawer closing to reset qtyloading state
  document.addEventListener('dispatch:cart-drawer:close', function() {
    const qtyloadingSwatch = document.querySelector('.swatch.qtyloading');
    if (qtyloadingSwatch) {
      qtyloadingSwatch.classList.remove('qtyloading');
    }
  });
});

async function addToCart(quantity) {
  try {
    // Find clicked swatch and add qtyloading state
    const clickedSwatch = event.currentTarget;
    clickedSwatch.classList.add('qtyloading');

    const variantId = document.getElementsByName("id")["0"].value;
    if (!variantId) {
      console.error('Variant ID not found');
      clickedSwatch.classList.remove('qtyloading');
      return;
    }

    // First, get current cart contents
    const cartResponse = await $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json'
    });

    // Remove each instance of the variant individually
    for (const item of cartResponse.items) {
      if (item.variant_id.toString() === variantId.toString()) {
        await $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: {
            id: item.variant_id,
            quantity: 0
          },
          dataType: 'json'
        });
      }
    }

    // Add new quantity based on selection
    await $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: quantity
      },
      dataType: 'json'
    });

    // If quantity is 2, apply the discount code
    if (quantity === 2) {
      $.ajax({
        type: 'GET',
        url: '/discount/BUY2',
        dataType: 'json'
      })
    }

    // Refresh and open cart drawer
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
      bubbles: true
    }));
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));

    // Remove qtyloading state after a brief delay to ensure smooth transition
    setTimeout(() => {
      clickedSwatch.classList.remove('qtyloading');
    }, 500);

  } catch (error) {
    console.error('Error updating cart:', error);
    // Remove qtyloading state if there's an error
    const qtyloadingSwatch = document.querySelector('.swatch.qtyloading');
    if (qtyloadingSwatch) {
      qtyloadingSwatch.classList.remove('qtyloading');
    }
  }
}

// Function to check if cart contains a combo product and modify checkout button
function checkForComboAndModifyButton() {
  // Wait for cart drawer to be fully loaded
  setTimeout(function() {
    // Find all cart item titles
    const cartItemTitles = document.querySelectorAll('.cart-item__title');
    
    // Flag to track if we found a combo product
    let hasCombo = false;
    
    // Check each item title for the word "combo"
    cartItemTitles.forEach(title => {
      if (title.textContent.toLowerCase().includes('combo')) {
        hasCombo = true;
      }
    });
    
    // If we found a combo product, modify the checkout button
    if (hasCombo) {
      // Find the checkout button (adjust selectors based on your theme)
      const checkoutButton = document.querySelector('.gokwik-checkout');
      
      if (checkoutButton) {
        // Hide the original checkout button
        checkoutButton.style.display = 'none';
        
        // Create a new button
        const newButton = document.createElement('button');
        newButton.className = "btn btn--primary btn--icon-with-text w-full"; 
        newButton.textContent = 'Checkout';
        newButton.type = 'button';
        
        // Add functionality to the new button
        newButton.addEventListener('click', function() {
          // Redirect to your custom page or show a popup
          window.location.href = '/checkout';
        });
        
        // Add the new button where the old one was
        checkoutButton.parentNode.insertBefore(newButton, checkoutButton);
      }
    }
  }, 1000); // Adjust timeout as needed for your site
}

// Run the function when the page loads
document.addEventListener('DOMContentLoaded', checkForComboAndModifyButton);

document.addEventListener('on:cart-drawer:after-open', (event) => {
  checkForComboAndModifyButton();
});

document.addEventListener('on:line-item:change', (event) => {
  checkForComboAndModifyButton();
});

/**
 * Jackend Product Groups Widget for Shopify
 * 
 * Installation:
 * 1. Add this script to your theme's assets folder
 * 2. Include it in your product template
 * 3. Add the widget container div where you want the groups to appear
 * 
 * Usage:
 * <div id="jackend-product-groups"></div>
 * <script>
 *   JackendProductGroups.init({
 *     apiUrl: 'https://your-jackend-domain.com/api/product_groups.php',
 *     productId: '{{ product.id }}',
 *     containerId: 'jackend-product-groups'
 *   });
 * </script>
 */

(function(window) {
    'use strict';
    
    const JackendProductGroups = {
        config: {
            apiUrl: '',
            productId: null,
            containerId: 'jackend-product-groups',
            shopDomain: window.Shopify ? window.Shopify.shop : '',
            autoScroll: true,
            showTitle: true,
            maxVisible: 6
        },
        
        /**
         * Initialize the widget
         */
        init: function(options) {
            this.config = Object.assign(this.config, options);
            
            if (!this.config.apiUrl || !this.config.productId) {
                console.error('Jackend Product Groups: API URL and Product ID are required');
                return;
            }
            
            this.loadProductGroups();
        },
        
        /**
         * Load product groups from API
         */
        loadProductGroups: function() {
            const self = this;
            const url = `${this.config.apiUrl}?product_id=${this.config.productId}`;
            
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    if (data.success && data.groups && data.groups.length > 0) {
                        self.renderGroups(data.groups);
                    } else {
                        self.hideContainer();
                    }
                })
                .catch(error => {
                    console.error('Jackend Product Groups: Error loading groups', error);
                    self.hideContainer();
                });
        },
        
        /**
         * Render product groups
         */
        renderGroups: function(groups) {
            const container = document.getElementById(this.config.containerId);
            if (!container) {
                console.error('Jackend Product Groups: Container not found');
                return;
            }
            
            container.innerHTML = '';
            
            groups.forEach(group => {
                if (group.products && group.products.length > 0) {
                    const groupElement = this.createGroupElement(group);
                    container.appendChild(groupElement);
                }
            });
            
            // Initialize scroll functionality
            this.initializeScroll();
        },
        
        /**
         * Create a single group element
         */
        createGroupElement: function(group) {
            const groupDiv = document.createElement('div');
            groupDiv.className = 'jackend-product-group';
            groupDiv.setAttribute('data-group-id', group.group_id);
            
            let html = '';
            
            if (this.config.showTitle) {
                html += `<h3 class="jackend-group-title">Variant: ${group.group_name}</h3>`;
            }
            
            html += '<div class="jackend-products-container">';
            html += '<div class="jackend-products-scroll">';
            
            group.products.forEach(product => {
                html += this.createProductHTML(product);
            });
            
            html += '</div>';
            
            if (this.config.autoScroll && group.products.length > this.config.maxVisible) {
                html += `
                    <button class="jackend-scroll-btn jackend-scroll-left" disabled>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="15,18 9,12 15,6"></polyline>
                        </svg>
                    </button>
                    <button class="jackend-scroll-btn jackend-scroll-right">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="9,18 15,12 9,6"></polyline>
                        </svg>
                    </button>
                `;
            }
            
            html += '</div>';
            
            groupDiv.innerHTML = html;
            return groupDiv;
        },
        
        /**
         * Create HTML for a single product
         */
        createProductHTML: function(product) {
            const productUrl = `/products/${product.product_handle}`;
            const imageUrl = product.product_image_url || '/assets/no-image.png';
            
            return `
                <div class="jackend-product-item">
                    <a href="${productUrl}" class="jackend-product-link">
                        <div class="jackend-product-image">
                            <img src="${imageUrl}" alt="${product.custom_title}" loading="lazy">
                        </div>
                        <div class="jackend-product-title">
                            ${product.custom_title}
                        </div>
                    </a>
                </div>
            `;
        },
        
        /**
         * Initialize scroll functionality
         */
        initializeScroll: function() {
            const groups = document.querySelectorAll('.jackend-product-group');
            
            groups.forEach(group => {
                const scrollContainer = group.querySelector('.jackend-products-scroll');
                const leftBtn = group.querySelector('.jackend-scroll-left');
                const rightBtn = group.querySelector('.jackend-scroll-right');
                
                if (!scrollContainer || !leftBtn || !rightBtn) return;
                
                const itemWidth = 200; // Approximate width of each product item
                const scrollAmount = itemWidth * 2; // Scroll 2 items at a time
                
                leftBtn.addEventListener('click', () => {
                    scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                });
                
                rightBtn.addEventListener('click', () => {
                    scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                });
                
                // Update button states on scroll
                scrollContainer.addEventListener('scroll', () => {
                    const scrollLeft = scrollContainer.scrollLeft;
                    const scrollWidth = scrollContainer.scrollWidth;
                    const clientWidth = scrollContainer.clientWidth;
                    
                    leftBtn.disabled = scrollLeft <= 0;
                    rightBtn.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
                });
                
                // Initial button state
                const scrollWidth = scrollContainer.scrollWidth;
                const clientWidth = scrollContainer.clientWidth;
                rightBtn.disabled = scrollWidth <= clientWidth;
            });
        },
        
        /**
         * Hide the container if no groups
         */
        hideContainer: function() {
            const container = document.getElementById(this.config.containerId);
            if (container) {
                container.style.display = 'none';
            }
        }
    };
    
    // CSS Styles
    const css = `
        .jackend-product-group {
            margin: 30px 0;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
        }
        
        .jackend-group-title {
            font-size: 24px;
            font-weight: 600;
            margin-bottom: 20px;
            color: #333;
            text-align: center;
        }
        
        .jackend-products-container {
            position: relative;
            overflow: hidden;
        }
        
        .jackend-products-scroll {
            display: flex;
            gap: 15px;
            overflow-x: auto;
            scroll-behavior: smooth;
            padding: 10px 0;
            scrollbar-width: none;
            -ms-overflow-style: none;
        }
        
        .jackend-products-scroll::-webkit-scrollbar {
            display: none;
        }
        
        .jackend-product-item {
            flex: 0 0 auto;
            width: 180px;
            background: #fff;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
            transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .jackend-product-item:hover {
            transform: translateY(-5px);
            box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        }
        
        .jackend-product-link {
            display: block;
            text-decoration: none;
            color: inherit;
        }
        
        .jackend-product-image {
            position: relative;
            width: 100%;
            height: 180px;
            overflow: hidden;
            background: #f8f9fa;
        }
        
        .jackend-product-image img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
        }
        
        .jackend-product-item:hover .jackend-product-image img {
            transform: scale(1.05);
        }
        
        .jackend-product-title {
            padding: 15px;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.4;
            color: #333;
            text-align: center;
            min-height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .jackend-scroll-btn {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 40px;
            height: 40px;
            border: none;
            border-radius: 50%;
            background: rgba(255,255,255,0.9);
            box-shadow: 0 2px 8px rgba(0,0,0,0.15);
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            z-index: 10;
        }
        
        .jackend-scroll-btn:hover:not(:disabled) {
            background: #fff;
            box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        }
        
        .jackend-scroll-btn:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
        
        .jackend-scroll-left {
            left: 10px;
        }
        
        .jackend-scroll-right {
            right: 10px;
        }
        
        .jackend-scroll-btn svg {
            color: #333;
        }
        
        /* Mobile responsive */
        @media (max-width: 768px) {
            .jackend-product-item {
                width: 150px;
            }
            
            .jackend-product-image {
                height: 150px;
            }
            
            .jackend-group-title {
                font-size: 20px;
            }
            
            .jackend-scroll-btn {
                display: none;
            }
        }
        
        /* Dark theme support */
        @media (prefers-color-scheme: dark) {
            .jackend-group-title {
                color: #fff;
            }
            
            .jackend-product-item {
                background: #2a2a2a;
                box-shadow: 0 2px 8px rgba(0,0,0,0.3);
            }
            
            .jackend-product-title {
                color: #fff;
            }
            
            .jackend-scroll-btn {
                background: rgba(42,42,42,0.9);
            }
            
            .jackend-scroll-btn:hover:not(:disabled) {
                background: #2a2a2a;
            }
            
            .jackend-scroll-btn svg {
                color: #fff;
            }
        }
    `;
    
    // Inject CSS
    const styleSheet = document.createElement('style');
    styleSheet.textContent = css;
    document.head.appendChild(styleSheet);
    
    // Expose to global scope
    window.JackendProductGroups = JackendProductGroups;
    
})(window);